import { useMemo } from 'react'

import { useQuery } from 'react-query'
import BeatLoader from 'react-spinners/BeatLoader'

import chatBubbleInner from 'assets/images/temp/chatBubbleInner_fixed.png'
import chatBubbleOuter from 'assets/images/temp/chatBubbleOuter.svg'
import { getMassMessages } from 'services/endpoints/message'
import { type IMassMessage } from 'types/interfaces/IMessage'

import MassMessageCard from './components/MassMessageCard/MassMessageCard'


const MassMessagesModal = () => {
    const { data, isLoading } = useQuery(
        'mass-messages',
        getMassMessages
    )

    const visibleMessages = useMemo(() => {
        if (!data) return []

        return data.filter(
            (message: IMassMessage) =>
                !(message.actual_sent === 0 && message.viewed === 0)
        )
    }, [data])

    const initialLoad = isLoading && !data

    return (
        <div
            style={{
                maxHeight: '80vh',
                minHeight: '40vh'
            }}
        >
            {initialLoad ? (
                <div
                    style={{
                        minHeight: '40vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <BeatLoader size={8} />
                </div>
            ) : visibleMessages.length > 0 ? (
                visibleMessages.map(
                    (message: IMassMessage, index: number) => (
                        <MassMessageCard
                            key={message.id ?? index}
                            message={message}
                        />
                    )
                )
            ) : (
                <MassMessagesPlaceholder />
            )}
        </div>
    )
}

const MassMessagesPlaceholder = () => (
    <div className='mass-messages-placeholder'>
        <div className='messages__nomessages'>
            <div className='messages__nomessages__bubble'>
                <img
                    className='messages__nomessages--outer'
                    src={chatBubbleOuter}
                    alt='Chat bubble outer icon'
                />

                <img
                    className='messages__nomessages--inner'
                    src={chatBubbleInner}
                    alt='Chat bubble inner'
                />
            </div>

            <p className='messages__nomessages__text'>
                No Mass Messages
            </p>
        </div>
    </div>
)

export default MassMessagesModal